module.exports = __webpack_public_path__ + "img/image_0.23ddfc08.jpg";